"use client";

import {
  CallCalling,
  Instagram,
  Linkedin,
  Sms,
  Telegram,
  Youtube,
} from "@/asset/svgs";
import { Address, email, phone_number } from "@/static/texts";
import rippleEffect from "@/utils/rippleEffect";
import Link from "next/link";
import styles from "./layout.module.scss";

const SocialMediaList = [
  {
    logo: <Instagram />,
    link: "https://www.instagram.com/invex_exchange/",
  },
  {
    logo: <Telegram />,
    link: "https://t.me/invex_exchange",
  },
  {
    logo: <Linkedin />,
    link: "https://www.linkedin.com/company/invex-exchange/",
  },
  {
    logo: <Youtube />,
    link: "https://www.youtube.com/@invex-exchange",
  },
];

const AboutInvex = [
  {
    label: "قوانین و مقررات",
    link: "/terms-of-use",
  },
  // {
  //     label: "شرایط دعوت از دوستان",
  //     link: "#",
  // },
  {
    label: "تماس با ما",
    link: "/contact-us",
  },
  // {
  //     label: "فرصت های شغلی",
  //     link: "#",
  // },
];

const ImportantPage = [
  // {
  //     label: "پشتیبانی",
  //     link: "#",
  //     target: '',
  //     download: false
  // },
  {
    label: "اپلیکیشن موبایل",
    link: `/application`,
    target: undefined,
    download: true,
  },
  {
    label: "معاملات",
    link: `${process.env.APP_PANEL_URL}/login`,
    target: undefined,
    download: false,
  },
  {
    label: "سوالات متداول",
    link: "https://invex.ir/help/",
    target: undefined,
    download: false,
  },
  {
    label: "بلاگ اینوکس",
    link: "https://invex.ir/blog/",
    target: undefined,
    download: false,
  },
  {
    label: "کارمزدها",
    link: "/fees/",
    target: undefined,
    download: false,
  },
  {
    label: "لیست قیمت ارز دیجیتال",
    link: "/coins/",
    target: undefined,
    download: false,
  },
];

const BlogInvex = [
  {
    label: "آینده ارز شیبا اینو: پیش بینی قیمت شیبا",
    link: "https://invex.ir/blog/%D9%BE%DB%8C%D8%B4-%D8%A8%DB%8C%D9%86%DB%8C-%D8%A2%DB%8C%D9%86%D8%AF%D9%87-%D8%A7%D8%B1%D8%B2-%D8%B4%DB%8C%D8%A8%D8%A7-%D8%A7%DB%8C%D9%86%D9%88%D8%8C-%D8%A2%DB%8C%D8%A7-%D8%A7%DB%8C%D9%86-%DA%A9%D9%88/",
  },
  {
    label: "آینده اتریوم: پیش بینی قیمت اتریوم",
    link: "https://invex.ir/blog/%D9%BE%DB%8C%D8%B4-%D8%A8%DB%8C%D9%86%DB%8C-%D9%82%DB%8C%D9%85%D8%AA-%D8%A7%D8%AA%D8%B1%DB%8C%D9%88%D9%85%D8%8C-%D8%A2%DB%8C%D9%86%D8%AF%D9%87-%D8%A7%D8%AA%D8%B1%DB%8C%D9%88%D9%85/",
  },
  {
    label: "آینده بیبی دوج: پیش بینی قیمت بیبی دوج",
    link: "https://invex.ir/blog/%D8%A2%DB%8C%D9%86%D8%AF%D9%87-%D8%A8%DB%8C%D8%A8%DB%8C-%D8%AF%D9%88%D8%AC-%D9%BE%DB%8C%D8%B4-%D8%A8%DB%8C%D9%86%DB%8C-%D9%82%DB%8C%D9%85%D8%AA-%D8%A8%DB%8C%D8%A8%DB%8C-%D8%AF%D9%88%D8%AC/",
  },
  {
    label: "صفر تا صد ساخت کیف پول اتریوم با متامسک",
    link: "https://invex.ir/blog/%D8%B5%D9%81%D8%B1-%D8%AA%D8%A7-%D8%B5%D8%AF-%D8%B3%D8%A7%D8%AE%D8%AA-%DA%A9%DB%8C%D9%81-%D9%BE%D9%88%D9%84-%D8%A7%D8%AA%D8%B1%DB%8C%D9%88%D9%85-%D8%A8%D8%A7-%D9%85%D8%AA%D8%A7%D9%85%D8%B3%DA%A9/",
  },
  {
    label: "9 تا از بهترین ارزهای web3 برای سرمایه‌گذاری",
    link: "https://invex.ir/blog/%D8%A8%D9%87%D8%AA%D8%B1%DB%8C%D9%86-%D8%A7%D8%B1%D8%B2%D9%87%D8%A7%DB%8C-web3/",
  },
  {
    label: "آموزش ساخت NFT در OpenSea",
    link: "https://invex.ir/blog/%D8%A2%D9%85%D9%88%D8%B2%D8%B4-%D8%B3%D8%A7%D8%AE%D8%AA-nft-%D8%A8%D8%A7-%D9%BE%D9%84%D8%AA%D9%81%D8%B1%D9%85-opensea/",
  },
];

const CoinsLinks = [
  {
    label: "قیمت بیت کوین",
    link: "/coins/btc",
  },
  {
    label: "قیمت تتر",
    link: "/coins/eth",
  },
  {
    label: "قیمت دوج کوین",
    link: "/coins/doge",
  },
  {
    label: "قیمت ترون",
    link: "/coins/trx",
  },
  {
    label: "قیمت همستر کامبت",
    link: "/coins/hmstr",
  },
  {
    label: "قیمت داگز",
    link: "/coins/dogs",
  },
];

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.links_details}>
          <div className={styles.column}>
            <Link href="#" />
            <p className="font-title1 font-medium">
              ارتباط با پشتیبانی از ساعت 9 الی 20
            </p>
            <a href={`tel:${phone_number}`} className={styles.btn}>
              <div className="title">شماره پشتیبانی</div>
              <div className="value">{phone_number}</div>
              <CallCalling />
            </a>
            <a href={`mailto:${email}`} className={styles.btn}>
              <div className="title">پست الکترونیکی</div>
              <div className="value">{email}</div>
              <Sms />
            </a>
          </div>
          <div className={styles.column}>
            <p className="font-title1 font-medium">دسترسی سریع</p>
            {ImportantPage.map(({ label, link, target, download }) => (
              <Link
                className={`${styles.link} font-regular`}
                key={link}
                href={link}
                target={target}
                download={download ? "invex.apk" : false}
              >
                {label}
              </Link>
            ))}
          </div>
          <div className={styles.column}>
            <p className="font-title1 font-medium">قیمت لحظه ای ارز دیجیتال</p>
            {CoinsLinks.map(({ label, link }) => (
              <Link
                className={`${styles.link} font-regular`}
                key={link}
                href={link}
              >
                {label}
              </Link>
            ))}
          </div>
          <div className={styles.column}>
            <p className="font-title1 font-medium">راهنما</p>
            {AboutInvex.map(({ label, link }) => (
              <Link
                className={`${styles.link} font-regular`}
                key={link}
                href={link}
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
        <hr />
        <div className={styles.details}>
          <p>{Address}</p>
          <hr />
          <p>
            © {new Date().getFullYear()}, کلیه حقوق سایت برای اینوکس محفوظ است
          </p>
          <div className={styles.social}>
            {SocialMediaList.map((item) => (
              <Link
                href={item.link}
                key={item.link}
                onMouseDown={rippleEffect}
                onTouchStart={rippleEffect}
                draggable={false}
              >
                {item.logo}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
